<mat-toolbar color="primary">


<!-- BREADCRUMB NAVIGATION -->
<div style="display: flex; align-items: center; gap: 4px; padding: 8px 0;">
    <button mat-icon-button (click)="goToRoot()">
      <mat-icon>home</mat-icon>
    </button>
    <span *ngFor="let segment of breadcrumbSegments; let last = last">
      <mat-icon>chevron_right</mat-icon>
      <button mat-button *ngIf="!last" (click)="navigateToPath(segment.path)">
        {{ segment.label }}
      </button>
      <span *ngIf="last">{{ segment.label }}</span>
    </span>
  </div>

    <span>{{ currentPath || '/' }}</span>
    <span class="spacer"></span>
    <button mat-icon-button (click)="goUp()" [disabled]="!currentPath">
      <mat-icon>arrow_upward</mat-icon>
    </button>
    <button mat-icon-button (click)="changeViewMode('grid')">
      <mat-icon>grid_view</mat-icon>
    </button>
    <button mat-icon-button (click)="changeViewMode('list')">
      <mat-icon>list</mat-icon>
    </button>
  </mat-toolbar>
  
  <mat-form-field class="search-field">
    <input matInput placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="searchFiles()" />
    <button mat-button matSuffix (click)="searchFiles()">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>
  
  <!-- Grid view -->
  <div *ngIf="viewMode === 'grid'" class="grid-view">
    <mat-card *ngFor="let item of filteredItems" class="file-card" (click)="navigateTo(item)">
      <mat-icon class="file-icon">
        {{ item.isDirectory ? 'folder' : 'insert_drive_file' }}
      </mat-icon>
      <p>{{ item.name }}</p>

      <!-- PREVIEW -->
        <button mat-button color="primary"
                *ngIf="!item.isDirectory && isPreviewable(item.name)"
                (click)="previewFile(item)">
            <mat-icon>visibility</mat-icon>
        </button>

        <!-- DOWNLOAD -->
        <button mat-button color="primary" (click)="downloadFile(item)">
            <mat-icon>file_download</mat-icon>
        </button>
    </mat-card>
  </div>
  
  <!-- List view -->
  <div *ngIf="viewMode === 'list'" class="list-view">
    <mat-list>
      <mat-list-item *ngFor="let item of filteredItems" (click)="navigateTo(item)">
        <mat-icon matListIcon>
          {{ item.isDirectory ? 'folder' : 'insert_drive_file' }}
        </mat-icon>
        <h4 matLine>{{ item.name }}</h4>
        <!-- PREVIEW -->
        <button mat-button color="primary"
                *ngIf="!item.isDirectory && isPreviewable(item.name)"
                (click)="previewFile(item)">
            <mat-icon>visibility</mat-icon>
        </button>

        <!-- DOWNLOAD -->
        <button mat-button color="primary" (click)="downloadFile(item)">
            <mat-icon>file_download</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </div>
  